import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import { useSelector } from "react-redux";
import Modal from '../modals/Modal';
import Input from '../../components/input';
import DropdownComp from '../dropdown';
import FleUpload from '../fileUpload/FleUpload';
import ButtonContained from '../button';
import { TopUpSchema } from '../../validation/ValidationSchema';
import { api } from '../../api';
import { getBase64 } from '../../utils/converter';
import { toast } from "react-toastify";

const TopUp = (props) => {
  const token = useSelector((state) => state.auth.token);
  const { showTopUp, closeModal, merchentId, setUpdateData, merchantName } = props

  const [fileName, setFileName] = useState('')
  const [wait, setWait] = useState(false)

  const options = [
    { value: 1, label: "Bank Transfer Online" },
    { value: 2, label: "Cheque" },
    { value: 3, label: "UPI" }
  ];

  const handleFileChange = (name, e, setFieldValue) => {
    setFieldValue(name, e.currentTarget.files[0])
    getBase64(e.currentTarget.files[0], res => {
      setWait(true)
      api.upload.upload(res,token).then(res => {
     
        setFieldValue(`${name}Base64`, res.data)
   
        setFileName(res.data)
        setWait(false)
      }).catch(err => {
          toast.error("Something went wrong");
        setFieldValue(`${name}Base64`, {})
      })
    })
  }

  setUpdateData(false);

  return (
    <Modal
      id="Topup"
      showModal={showTopUp}
      closeModal={closeModal}
      modalHeader="TOP-UP"
      buttonText="PAY">
      <Formik
        validationSchema={TopUpSchema}
        enableReinitialize
        initialValues={{
          amount: '',
          paymentMode: '',
          txnId: '',
          txnProof: '',
          paymentDate: '',
          notes: '',
          paymentDoc: '',
          merchentId: merchentId
        }}
        onSubmit={(values, actions) => {
          console.log('transaction proof', values)
          const formBody = {
            paymentAmount: values.amount,
            paymentMode: values.paymentMode.value,
            paymentDate: values.paymentDate,
            transactionId: values.txnId,
            notes: values.notes,
            paymentDoc: fileName,
            merchentId: values.merchentId,
          }
          api.topup.create(formBody,token).then(res => {
            closeModal()
            if (res.success === false) {
              toast.error(res.message);
            }
            else {
              toast.success(res.message);
              setUpdateData(true);
            }
            setUpdateData(true)
          }).catch(err => {

          });
        }}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          touched,
          isValid,
          errors,
          isSubmitting,
          setFieldValue

        }) => {
          return (

            <>
              <div className="mb-3">MERCHANT : <b>{merchantName}</b></div>
              <Form onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group col-md-12">
                      <Input
                       name="paymentDate"
                       id="paymentDate"
                       type="date"
                       label="Payment Date"
                       value={values.paymentDate}
                       onChange={handleChange}
                       disabled={isSubmitting}
                       error={touched.paymentDate && errors.paymentDate}
                       errorText={errors.paymentDate} />
                  </div>
                  <div className="form-group col-md-12">
                    <Input
                      id="amount"
                      name="amount"
                      placeholder="Enter amount"
                      type="number"
                      label="Amount"
                      value={values.amount}
                      onChange={handleChange}
                      error={touched.amount && errors.amount}
                      errorText={errors.amount}
                      disabled={isSubmitting} />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group col-md-12">
                    <DropdownComp
                      id="paymentMode"
                      name="paymentMode"
                      onChange={(selectedValue) => {
                        setFieldValue("paymentMode", selectedValue)
                      }}
                      value={values.paymentMode}
                      options={options}
                      label="Payment Mode"
                      placeholder="Please Select The Payment Mode"
                      error={touched.paymentMode && errors.paymentMode}
                      errorText={errors.paymentMode}
                      disabled={isSubmitting} />
                  </div>
                  <div className="form-group col-md-12">
                    <Input
                      id="txnId"
                      name="txnId"
                      placeholder="Enter transaction Id"
                      type="text"
                      label="Transaction/Reference ID"
                      value={values.txnId}
                      onChange={handleChange}
                      error={touched.txnId && errors.txnId}
                      errorText={errors.txnId}
                      disabled={isSubmitting} />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group col-md-12">
                    <label htmlFor="">Notes</label>
                    <textarea
                    name="notes"
                    id="notes"
                    value={values.notes}
                    onChange={handleChange}
                    className="w-100" 
                    disabled={isSubmitting}
                    >
                    </textarea>
                  </div>
                  <div className="form-group col-md-12">
                    <FleUpload
                      changeFileAlign = { true }
                      name="txnProof"
                      id="txnProof"
                      labelText="Transaction Proof"
                      value={(values.txnProof && values.txnProof.name) || ""}
                      onChange={(e) => {
                        handleFileChange('txnProof', e, setFieldValue);
                      }}
                      // error={touched.txnProof && errors.txnProof}
                      // errorText={errors.txnProof}
                      disabled={isSubmitting} />
                  </div>

                </div>
                <ButtonContained buttonName="Top Up" disabled={wait ? true : isSubmitting} />
              </Form>
            </>
          )
        }}
      </Formik >
    </Modal >
  );
}

export default TopUp;